import { Component, Input } from '@angular/core';

@Component({
  selector: 'loading-indicator',
  templateUrl: './loading-indicator.component.html',
  standalone: true,
  imports: []
})
export class LoadingIndicatorComponent {
  @Input() label: string;
}
